import React from 'react';
import { SvgLoader, SvgProxy } from 'react-svgmt';
import { palette } from '../design-system/colors';
import { observer } from 'mobx-react';
import { resourcePath } from '../../utils/helpers';

/**
 * Step indicator in assessment.
 */

export const ThemedAssessmentStepIndicator = observer(
    ({ primaryColor, isCurrent, isActive }) => {
        const iconPath = resourcePath(
            isCurrent
                ? '/static/img/icon-step-active.svg'
                : '/static/img/icon-step.svg'
        );
        return (
            <span
                style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: isCurrent ? 40 : 28,
                    height: isCurrent ? 40 : 28,
                    flexShrink: 0,
                    lineHeight: 0,
                    overflow: 'hidden',
                }}
            >
                <SvgLoader path={iconPath}>
                    <SvgProxy
                        selector="circle"
                        fill={isActive ? primaryColor : palette.graphite.ash}
                    />
                </SvgLoader>
            </span>
        );
    }
);
